import React, { useEffect, useState } from 'react'
import Graytextarea from '../../../components/Graytextarea'
import { useIndexedDB } from '../../../context/IndexedContext'
import toast from 'react-hot-toast'
import GraytextareaAdjustable from '../../../components/GrayTextareaAdjustable'

const IncidentGlobalRecords = ({ patientDBdata, isSavingTheData, patientID, loggedUserProvider, setPatientDBdata, noteId }) => {
  const [visible, setVisible] = useState(false)
  const [allDiagnosis, setAllDiagnosis] = useState([])
  const [date, setDate] = useState('')
  const [incidentRemark, setIncidentRemark] = useState('')
  const [tempIncidentRemark, setTempIncidentRemark] = useState('')
  const [tempModalIncidentRemark, setTempModalIncidentRemark] = useState('')
  const [toggleToAddIncidentRemark, setToggleToAddIncidentRemark] = useState(false)
  const [isAddingNewIncident, setIsAddingNewIncident] = useState(false)
  const [dbData, setDbData] = useState({})

  const { getHPIDiagnosisData, getAllMasterDiagnosis, getOfflineData, saveOfflineData, getProviderDetails, getOpenChartOfflineData, saveOpenChartOfflineData } = useIndexedDB()
  useEffect(() => {
    const fetchHPIMasterFromDB = async () => {
      const data = await getHPIDiagnosisData()
      setDbData(data)
    }
    fetchHPIMasterFromDB()
  }, [])

  const handleAddNewIncident = async () => {
    setIsAddingNewIncident(true)
    const findDiagnosisId = allDiagnosis?.find((item) => item.label === selectedDiagnosis)
    if (findDiagnosisId) {
      // let data = await SaveQuestionProvider('GET', '', 'Incident', findDiagnosisId?.value, '')
      // data = JSON.parse(data?.d)?.Data || []
      // const allParsedData = data.flatMap((item) => {
      //   try {
      //     const parsed = JSON.parse(item.questionData)
      //     return Array.isArray(parsed) ? parsed : []
      //   } catch (err) {
      //     console.error('Invalid JSON in questionData:', item.questionData)
      //     return []
      //   }
      // })
      let allParsedData = dbData[findDiagnosisId?.label]?.['Incident']?.questionData || []
      if (allParsedData.length > 0) {
        let isoString
        if (date) {
          const [month, day, year] = date?.split('/')
          const dateToIso = new Date(`${year}-${month}-${day}`)
          isoString = dateToIso.toISOString()
        }
        setAllIncidents([...allIncidents, { diagnosis: findDiagnosisId?.label, date: isoString, incidents: allParsedData }])

        setVisible(false)
        setDate('')
        setSelectedDiagnosis(null)
      } else {
        setIsAddingNewIncident(false)
        toast.error('No incident question are available', toastConfig)
        return
      }
    }
    setIsAddingNewIncident(false)
  }
  const [selectedDiagnosis, setSelectedDiagnosis] = useState(null)
  const [allIncidents, setAllIncidents] = useState([])
  console.log(allIncidents, 'allIncidents')

  const handleDateChange = (e) => {
    console.log('dateeeee===>', e)
    setDate(e)
  }

  // useEffect(() => {
  //     const incidentObj = noteStructureRef?.current?.incident;
  //     if (!incidentObj) return;

  //     const allKeys = Object.keys(incidentObj);
  //     console.log(allKeys, "allKeys");

  //     const structuredIncidents = allKeys
  //         .filter(key => Array.isArray(incidentObj[key]))
  //         .map(key => {
  //             const [diagnosis, date] = key.split("_");
  //             return {
  //                 diagnosis,
  //                 date,
  //                 incidents: incidentObj[key]
  //             };
  //         });

  //     setAllIncidents(structuredIncidents);
  // }, [noteStructureRef?.current]);

  console.log(patientID, 'patientID')

  useEffect(() => {
    const fetchIncidentData = async () => {
      let providerDetails = await getProviderDetails()
      const providerId = providerDetails?.ID
      let incideRemrk = patientDBdata?.currentNote?.data?.incidentRemark || ''
      let offlineIncidentData = patientDBdata?.currentNote.data.incident
      if (offlineIncidentData) {
        const allKeys = Object.keys(offlineIncidentData)

        const structuredIncidents = allKeys
          .filter((key) => Array.isArray(offlineIncidentData[key]))
          .map((key) => {
            const [diagnosis, date] = key.split('_')
            return {
              diagnosis,
              date,
              incidents: offlineIncidentData[key],
            }
          })

        setAllIncidents(structuredIncidents)
      }

      console.log(incideRemrk, 'incideRemrk')

      setIncidentRemark(incideRemrk || '')
      setTempIncidentRemark(incideRemrk || '')
    }
    fetchIncidentData()
  }, [patientID])

  const [freetypeModal, setFreetypeModal] = useState(false)
  const [currentIncidentIndex, setCurrentIncidentIndex] = useState(null)
  const [newFreeTypeText, setNewFreeTypeText] = useState('')
  // fetch diagnosis
  const fetchDiagnosis = async () => {
    let diagnosisData = await getAllMasterDiagnosis()
    diagnosisData = diagnosisData?.Data
    // let diagnosisData = await GetDiagnosisData('')
    // diagnosisData = JSON.parse(diagnosisData.d)?.Data
    if (diagnosisData.length > 0) {
      const allDiagnosisOpt = diagnosisData
        .map((diagnosis) => {
          return {
            value: diagnosis.id,
            label: diagnosis.Name,
          }
        })
        ?.sort((a, b) => a.label.localeCompare(b.label))
      setAllDiagnosis(allDiagnosisOpt)
    }
  }

  const handleDeleteIncident = async (index, diagnosis, date) => {
    const incidentName = `${diagnosis}_${date}`

    const updatedIncidents = allIncidents.filter((_, i) => i !== index)

    let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    let providerDetails = await getProviderDetails()

    const providerId = providerDetails?.ID
    if (!providerId || !patientID) return

    offlineData = offlineData || {}
    console.log(offlineData, 'offlineData before delete')
    offlineData[providerId] = offlineData[providerId] || {}
    offlineData[providerId][patientID] = offlineData[providerId][patientID] || {}
    offlineData[providerId][patientID].currentNote = offlineData[providerId][patientID].currentNote || {}

    if (!offlineData[providerId][patientID].currentNote.data) {
      offlineData[providerId][patientID].currentNote.data = {}
    }
    const currentIncidents = { ...(offlineData?.[providerId]?.[patientID]?.currentNote?.data?.incident || {}) }

    delete currentIncidents[incidentName]

    noteStructureRef.current = {
      ...noteStructureRef.current,
      incident: currentIncidents,
    }

    setAllIncidents(updatedIncidents)

    offlineData[providerId][patientID].currentNote.data.incident = currentIncidents

    // await saveOfflineData(offlineData)
    noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)

    // await saveTreatsShell(false)

    toast.success('Incident Deleted', toastConfig)
  }

  useEffect(() => {
    fetchDiagnosis()
  }, [visible])

  console.log(noteId, 'noteId')
  // const handleAddDataOffline = async () => {
  // let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
  // let providerDetails = await getProviderDetails();

  // console.log(offlineData, providerDetails, 'offlineData');

  // const providerId = providerDetails?.ID;
  // if (!providerId || !patientID) return;

  // offlineData = offlineData || {};
  // offlineData[providerId] = offlineData[providerId] || {};
  // offlineData[providerId][patientID] = offlineData[providerId][patientID] || {};
  // offlineData[providerId][patientID].currentNote =
  //     offlineData[providerId][patientID].currentNote || {};

  // if (!offlineData[providerId][patientID].currentNote.data) {
  //     offlineData[providerId][patientID].currentNote.data = {};
  // }
  // if (!offlineData[providerId][patientID].currentNote.data.incident) {
  //     offlineData[providerId][patientID].currentNote.data.incident = {};
  // }

  // console.log('Before adding incidents:', offlineData);

  // allIncidents.forEach((item) => {
  //     const key = `${item.diagnosis}_${item.date}`;
  //     offlineData[providerId][patientID].currentNote.data.incident[key] =
  //         item?.incidents || [];
  // });

  // console.log('After adding incidents:', offlineData);

  // noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)
  // }
  const handleAddDataOffline = async () => {
    const buildIncidentObject = (allIncidents = []) => {
      console.log('building object', allIncidents)
      return allIncidents.reduce((acc, item) => {
        const key = `${item.diagnosis}_${item.date}`
        acc[key] = Array.isArray(item?.incidents) ? item.incidents : []
        return acc
      }, {})
    }

    const incidentObject = buildIncidentObject(allIncidents)

    setPatientDBdata((prev) => {
      return {
        ...prev,
        currentNote: {
          ...prev?.currentNote,
          data: {
            ...prev?.currentNote?.data,
            incident: incidentObject,
            incidentRemark: tempIncidentRemark,
          },
        },

        allNotes: prev?.allNotes?.map((note) => {
          if (note?.id === noteId) {
            const parsedData = note?.data ? JSON.parse(note.data) : {}

            return {
              ...note,
              data: JSON.stringify({
                ...parsedData,
                incident: incidentObject,
                incidentRemark: tempIncidentRemark,
              }),
            }
          }
          return note
        }),
      }
    })
  }

  const handleAddFreeRemarkOffline = async (text) => {
    // let offlineData = noteCallType === 'OpenChart' ? await getOpenChartOfflineData() : await getOfflineData()
    // let providerDetails = await getProviderDetails();

    // console.log(offlineData, providerDetails, 'offlineData');

    // const providerId = providerDetails?.ID;
    // if (!providerId || !patientID) return;

    // offlineData = offlineData || {};
    // offlineData[providerId] = offlineData[providerId] || {};
    // offlineData[providerId][patientID] = offlineData[providerId][patientID] || {};
    // offlineData[providerId][patientID].currentNote =
    //     offlineData[providerId][patientID].currentNote || {};

    // if (!offlineData[providerId][patientID].currentNote.data) {
    //     offlineData[providerId][patientID].currentNote.data = {};
    // }
    // if (!offlineData[providerId][patientID].currentNote.data.incident) {
    //     offlineData[providerId][patientID].currentNote.data.incidentRemark = ""
    // }

    // offlineData[providerId][patientID].currentNote.data.incidentRemark = text

    // noteCallType === 'OpenChart' ? await saveOpenChartOfflineData(offlineData) : await saveOfflineData(offlineData)

    // setAddedNewIncident((p) => !p)

    setPatientDBdata((prev) => {
      return {
        ...prev,
        currentNote: {
          ...prev.currentNote,
          data: {
            ...prev.currentNote.data,
            incidentRemark: text,
          },
        },
      }
    })
  }

  const [savingIncidentLocally, setSavingIncidentLocally] = useState(false)
  const handleSave = async () => {
    // setSavingIncidentLocally(true)
    await handleAddDataOffline()
    // allIncidents.forEach((item) => {
    //     const key = `${item.diagnosis}_${item.date}`
    //     console.log(key)
    //     noteStructureRef.current = {
    //         ...noteStructureRef.current,
    //         incident: {
    //             ...noteStructureRef.current.incident,
    //             [key]: item?.incidents || [],
    //         },
    //     }
    // })
    // await saveTreatsShell(false)
    // setAddedNewIncident((p) => !p)
    // toast.success('Saved')
    // setSavingIncidentLocally(false)
    // setTimeout(() => {
    // }, 5000)
  }

  const updateIncidentAnswerById = (incidents, targetId, updater) => {
    return incidents.map((q) => {
      if (q.id === targetId) {
        return updater(q)
      } else if (q.options?.some((opt) => opt.linkedQuestion?.length)) {
        // find selected options
        let selectedOptions = []
        if (q.isMultiple) {
          const answerArray = q.answer ? q.answer.split(',').map((v) => v.trim()) : []
          selectedOptions = q.options.filter((opt) => answerArray.includes(opt.label))
        } else {
          selectedOptions = q.options.filter((opt) => opt.label === q.answer)
        }
        const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

        return {
          ...q,
          options: q.options.map((opt) => {
            if (linkedQuestions?.length) {
              const isSelected = selectedOptions.some((sel) => sel.label === opt.label)
              if (isSelected) {
                return {
                  ...opt,
                  linkedQuestion: updateIncidentAnswerById(linkedQuestions, targetId, updater),
                }
              }
            }
            return opt
          }),
        }
      }
      return q
    })
  }

  const updateIncidentAtIndex = (incidentIndex, questionId, updater) => {
    setAllIncidents((prevData) => {
      const newData = [...prevData]
      const incident = { ...newData[incidentIndex] }
      incident.incidents = updateIncidentAnswerById(incident.incidents, questionId, updater)
      newData[incidentIndex] = incident
      return newData
    })
  }

  const renderIncidentQuestion = (item, incidentIndex, questionIndex, parentPath = []) => {
    const currentPath = [...parentPath, item.id]
    if (!item.answer && !item.freeType) return
    const displayText = item?.isMultiple
      ? item?.answer
          ?.split(',')
          .map((v) => v.trim())
          .filter(Boolean)
          .join(', ') || '—'
      : item?.answer || '—'

    return (
      <div key={item.id} className="mb-3">
        <div className="d-flex align-items-center gap-1 mb-2">
          <p className="mb-0">{currentPath.length === 1 ? questionIndex + 1 : '-'}.</p>
          <p className="mb-0">{item?.label}</p>
        </div>

        {item.type === 'dropdown' && (
          //   <Select
          //     isMulti={item?.isMultiple}
          //     menuIsOpen={item?.isMultiple ? undefined : item?.menuIsOpen}
          //     closeMenuOnSelect={!item?.isMultiple}
          //     styles={{
          //       control: (base, state) => ({
          //         ...base,
          //         backgroundColor: '#191919',
          //         borderColor: state.isFocused ? '#444' : '#444',
          //         borderRadius: '6px',
          //         boxShadow: 'none',
          //         '&:hover': {
          //           borderColor: '#444',
          //         },
          //       }),
          //       menu: (base) => ({
          //         ...base,
          //         backgroundColor: '#000',
          //         borderRadius: '6px',
          //       }),
          //       option: (base, state) => ({
          //         ...base,
          //         backgroundColor: state.isSelected
          //           ? '#191919' // blue for selected
          //           : state.isFocused
          //             ? '#2a2a2a'
          //             : '#000',
          //         color: 'white',
          //         cursor: 'pointer',
          //         padding: '12px 14px',
          //         borderBottom: '1px solid #333',
          //         ':last-of-type': {
          //           borderBottom: 'none',
          //         },
          //         ':active': {
          //           backgroundColor: '#2a2a2a',
          //         },
          //       }),
          //       multiValue: (base) => ({
          //         ...base,
          //         backgroundColor: '#191919',
          //         borderRadius: '4px',
          //         border: '1px solid #454545ff',
          //       }),
          //       multiValueLabel: (base) => ({
          //         ...base,
          //         color: 'white',
          //       }),
          //       multiValueRemove: (base) => ({
          //         ...base,
          //         color: 'white',
          //         ':hover': {
          //           backgroundColor: '#333',
          //           color: 'white',
          //         },
          //       }),
          //       singleValue: (base) => ({
          //         ...base,
          //         color: 'white',
          //       }),
          //       placeholder: (base) => ({
          //         ...base,
          //         color: '#aaa',
          //       }),

          //       input: (base) => ({
          //         ...base,
          //         color: 'white',
          //       }),
          //       dropdownIndicator: (base) => ({
          //         ...base,
          //         color: 'white',
          //         ':hover': { color: 'white' },
          //       }),
          //     }}
          //     onChange={(selected) => {
          //       let selectedValues = ''
          //       let selectedValuesArr = []
          //       if (item?.isMultiple) {
          //         selectedValuesArr = selected?.map((opt) => opt.value) || []
          //         selectedValues = selectedValuesArr.join(', ')
          //       } else {
          //         selectedValues = selected?.value || ''
          //       }
          //       updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, answer: selectedValues }))

          //       // setAllIncidents((prevData) =>
          //       //     prevData.map((incidentBlock) => ({
          //       //         ...incidentBlock,
          //       //         incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: selectedValues })),
          //       //     })),
          //       // )
          //     }}
          //     value={item?.isMultiple ? (item?.answer && item.answer.trim() ? item.answer.split(',').map((val) => ({ value: val.trim(), label: val.trim() })) : []) : item?.answer && item.answer.trim() ? { value: item.answer, label: item.answer } : null}
          //     options={item.options?.map((opt) => ({ value: opt.label, label: opt.label })) || []}
          //     placeholder="Select an option"
          //     isClearable={!item?.isMultiple}
          //   />
          <input
            onBlur={handleSave}
            type="text"
            className="form-control mt-2"
            value={item.answer || ''}
            // onChange={(e) => {
            //   const val = e.target.value
            //   setAllIncidents((prevData) =>
            //     prevData.map((incidentBlock) => ({
            //       ...incidentBlock,
            //       incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: val })),
            //     })),
            //   )
            // }}
            onChange={(e) => {
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, answer: e.target.value }))
            }}
            style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }}
            placeholder="Enter your text"
          />
        )}

        {item.type === 'input' && (
          <input
            onBlur={handleSave}
            type="text"
            className="form-control mt-2"
            value={item.answer || ''}
            // onChange={(e) => {
            //   const val = e.target.value
            //   setAllIncidents((prevData) =>
            //     prevData.map((incidentBlock) => ({
            //       ...incidentBlock,
            //       incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, answer: val })),
            //     })),
            //   )
            // }}
            onChange={(e) => {
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, answer: e.target.value }))
            }}
            style={{ width: '100%', minHeight: '20px', background: '#2D2D2D', border: 0, color: 'white' }}
            placeholder="Enter your text"
          />
        )}

        {item.options?.map((opt) => {
          let isSelected = false
          if (item?.isMultiple) {
            const answerArray = item?.answer ? item.answer.split(',').map((v) => v.trim()) : []
            isSelected = answerArray.includes(opt.label)
          } else {
            isSelected = item?.answer === opt.label
          }
          const linkedQuestions = Array.isArray(opt.linkedQuestion) ? opt.linkedQuestion : opt.linkedQuestion ? [opt.linkedQuestion] : []

          return (
            isSelected &&
            linkedQuestions?.length > 0 && (
              <div key={`${opt.label}-${item.id}`} className="ml-3 mt-3 border-start ps-3">
                {linkedQuestions.map((nestedItem) => renderIncidentQuestion(nestedItem, incidentIndex, currentPath))}
              </div>
            )
          )
        })}

        <span className="d-block pt-2">
          <GraytextareaAdjustable
            value={item.freeType || ''}
            onBlur={handleSave}
            // onChange={(e) => {
            //   const val = e.target.value
            //   setAllIncidents((prevData) =>
            //     prevData.map((incidentBlock) => ({
            //       ...incidentBlock,
            //       incidents: updateIncidentAnswerById(incidentBlock.incidents, item.id, (q) => ({ ...q, freeType: val })),
            //     })),
            //   )
            // }}
            onChange={(e) => {
              updateIncidentAtIndex(incidentIndex, item.id, (q) => ({ ...q, freeType: e.target.value }))
            }}
            height={'100px'}
            placeholder={'Freetype'}
          />
        </span>
      </div>
    )
  }

  if (!allIncidents.length && !incidentRemark) return null

  return (
    <div className="d-flex align-items-start ">
      <div style={{ minWidth: '23%' }}>Incidents</div>
      <div className="w-100">
        {incidentRemark && (
          <GraytextareaAdjustable
            value={tempIncidentRemark}
            onBlur={() => {
              setIncidentRemark(tempIncidentRemark)
            }}
            onChange={(e) => {
              //    setIncidentRemark(e.target.value)
              setTempIncidentRemark(e.target.value)
            }}
          />
        )}
        {allIncidents.length > 0 &&
          allIncidents.map((incident, index) => {
            return (
              <div itemKey={1} className="mt-2">
                <div className="">
                  <div className="d-flex justify-content-between w-100">
                    <div>
                      {incident?.diagnosis} -{' '}
                      {incident?.date &&
                        new Intl.DateTimeFormat('en-US', {
                          month: '2-digit',
                          day: '2-digit',
                          year: 'numeric',
                        }).format(new Date(incident.date))}
                    </div>
                    <div className="d-flex gap-2 align-items-center me-2">
                      <span
                        className=""
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          handleDeleteIncident(index, incident?.diagnosis, incident?.date)
                        }}
                      ></span>
                      <span
                        variant="outline"
                        color="secondary"
                        onClick={(e) => {
                          e.stopPropagation()
                          e.preventDefault()
                          setCurrentIncidentIndex(index)
                          setFreetypeModal(true)
                          const incidentData = allIncidents[index]
                          const firstItem = incidentData?.incidents?.[0]

                          if (firstItem?.freeRemark) {
                            setNewFreeTypeText(firstItem.freeRemark) // set if it exists
                          } else {
                            setNewFreeTypeText('') // empty input if not available
                          }

                          setFreetypeModal(true)
                        }}
                      ></span>
                    </div>
                  </div>
                </div>
                <div className="w-100">
                  {/* {incident?.incidents.length > 0 ? (
                          <div>
                            {incident?.incidents?.[0]?.freeRemark && <p className="">{incident?.incidents?.[0]?.freeRemark}</p>}
                            {incident?.incidents.map((item, itemIndex) => (
                              <div key={item.id} className="mb-3">
                                <div className="d-flex items-center gap-1">
                                  <p>{itemIndex + 1}.</p>
                                  <p>{item?.label}</p>
                                </div>

                                {item.type === 'dropdown' && (
                                  <Select
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          answer: e.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    placeholder="Select an option"
                                    value={item.answer ? { value: item.answer, label: item.answer } : null}
                                    options={
                                      item.options?.map((opt) => ({
                                        value: opt.label,
                                        label: opt.label,
                                      })) || []
                                    }
                                  />
                                )}

                                <span className="d-block pt-2">
                                  <Graytextarea
                                    value={item.freeType}
                                    onChange={(e) => {
                                      setAllIncidents((prevData) => {
                                        const newData = [...prevData]
                                        const incidentCopy = { ...newData[index] }
                                        const updatedItems = [...incidentCopy.incidents]
                                        updatedItems[itemIndex] = {
                                          ...updatedItems[itemIndex],
                                          freeType: e.target.value,
                                        }
                                        incidentCopy.incidents = updatedItems
                                        newData[index] = incidentCopy
                                        return newData
                                      })
                                    }}
                                    height={'100px'}
                                    placeholder={'Freetype'}
                                  />
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No Questions Available</p>
                        )} */}

                  {incident?.incidents.length > 0 ? (
                    <div>
                      {incident?.incidents?.[0]?.freeRemark && <p style={{ whiteSpace: 'pre-line' }}>{incident?.incidents?.[0]?.freeRemark}</p>}
                      {incident.incidents.map((item, itemIndex) => renderIncidentQuestion(item, index, itemIndex))}
                    </div>
                  ) : (
                    <p>No Questions Available</p>
                  )}
                </div>
              </div>
            )
          })}
      </div>
    </div>
  )
}

export default IncidentGlobalRecords
